import { render } from "./GuideDetail.vue?vue&type=template&id=1d2856d6&scoped=true"
import script from "./GuideDetail.vue?vue&type=script&lang=js"
export * from "./GuideDetail.vue?vue&type=script&lang=js"

import "./GuideDetail.vue?vue&type=style&index=0&id=1d2856d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2856d6"]])

export default __exports__